import { lighten, Skeleton, Stack } from "@mui/material";
import { BG_COLORS, BORDER_COLORS } from "../../../../constants";

export const CurrentPlanSkeleton = () => {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
      gap={3}
      px={3}
      py={2}
      border={`1px solid ${lighten(BORDER_COLORS.default, 0.5)}`}
      borderRadius={1}
      bgcolor={BG_COLORS.default}
    >
      <Skeleton variant="rectangular" width={22} height={22} />
      <Stack flex={1} gap={0.5}>
        <Skeleton height={18} width={140} />
        <Skeleton height={14} width={110} />
        <Skeleton height={14} width={220} />
      </Stack>
      <Skeleton variant="circular" height={20} width={20} />
    </Stack>
  );
};
